module.exports = __webpack_public_path__ + "static/media/logo_top_bar.024d7deb.png";